import { cn } from '@/lib/utils'
import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import SectionHead from '@/v2/components/sections/landing-pages/section-head'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { CardType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'

interface TwoCardsSectionProps {
  title: string
  description?: string
  cards: CardType[]
  className?: string
  isBgDark?: boolean
}

const TwoCardsSection: React.FC<TwoCardsSectionProps> = props => {
  const { title, description, cards, className, isBgDark = false } = props

  return (
    <LazyMotion features={domAnimation}>
      <m.section
        viewport={{ once: false, amount: 0.2 }}
        className={cn('landing-pages-wr section-spacing', isBgDark ? 'bg-[#F9F8F8]' : '', className)}
      >
        <SectionWrapper className='xl:max-w-[1350px]'>
          <SectionHead title={title} description={description} />

          <div className='grid md-mn:grid-cols-2 grid-cols-1 md-mn:gap-[19px] lg-mn:gap-[34px] xl-min:gap-12 gap-6'>
            {cards.map(card => {
              return (
                <m.article
                  key={card.id}
                  whileInView='visible'
                  initial='hidden'
                  viewport={{ once: false, amount: 0.2 }}
                  className={cn(`flex items-center flex-col p-5 gap-4 lg-mn:gap-6 `)}
                >
                  {card.image && (
                    <div className='self-center lh-mn:self-start'>
                      <ResponsiveImage
                        src={card.image.src}
                        alt={card.image.alt}
                        className={cn('xl-min:!h-[387px] xl-min:!w-[593px] w-[346px] h-[226px]')}
                      />
                    </div>
                  )}

                  <div className='[&>h3]:mb-[11px] xl-min:[&>h3]:text-xl w-full [&>h3]:text-lg [&>h3]:font-semibold [&>h3]:text-paragraph [&>h3]:leading-8'>
                    <h3>{card.title}</h3>
                    <p className='text-paragraph leading-6 font-normal text-base'>{card.description}</p>
                  </div>
                </m.article>
              )
            })}
          </div>
        </SectionWrapper>
      </m.section>
    </LazyMotion>
  )
}

export default TwoCardsSection
